
// The below algorithm was found here:
// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
export const hashCode = (key: string) => {
    let hash = 0;
    let i;
    let chr;
    if (key.length === 0) { return hash; }
    for (i = 0; i < key.length; i++) {
        chr   = key.charCodeAt(i);
        // tslint:disable:no-bitwise
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

export const createManagerIdsUrl = (managerSourceIds: string[]): string => {
    return `&managerSourceIds=${managerSourceIds.join('&managerSourceIds=')}`;
};

// funtion for exporting csv string on the front end
export const escapeText = (value: string): string => {
    let clean = quoteMaliciousCsvCharacters(value);
    if (clean.includes('"')) {
        clean = `"${clean.replace('"', '""')}"`;
    }
    if (clean.includes(',') || clean.match('[\\n\\r]')) {
        clean = `"${clean}"`;
    }
    return clean;
};

export const quoteMaliciousCsvCharacters = (value: string): string => {
    return value.replace(/[=+\-@]/g, (x) => `"${x}"`);
};